let mediaRecorder: MediaRecorder | null = null;
let audioChunks: Blob[] = [];

export const startAudioRecording = async (): Promise<void> => {
  if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    mediaRecorder = new MediaRecorder(stream);

    mediaRecorder.ondataavailable = (event) => {
      audioChunks.push(event.data);
    };

    mediaRecorder.onstop = () => {
      const audioBlob = new Blob(audioChunks, { type: 'audio/wav' });
      // We will handle the audio blob logic later
    audioChunks = [];
    };

    audioChunks = [];
    mediaRecorder.start();
  } else {
    throw new Error('Audio recording is not supported by this browser.');
  }
};

export const stopAudioRecording = (): Promise<Blob> => {
  return new Promise((resolve) => {
    if (mediaRecorder && mediaRecorder.state === 'recording') {
      mediaRecorder.onstop = () => {
        const audioBlob = new Blob(audioChunks, { type: 'audio/wav' });
        audioChunks = [];
        resolve(audioBlob);
      };
      mediaRecorder.stop();
    }
  });
};

export const abortAudioRecording = () => {
  if (mediaRecorder && mediaRecorder.state === 'recording') {
    mediaRecorder.stop();
    mediaRecorder.onstop = null;
    // Stop the tracks to turn off the microphone indicator
    mediaRecorder.stream.getTracks().forEach(track => track.stop());
    audioChunks = [];
  }
};